import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Talk2PayConnection } from "@/components/screens/Platforms/Talk2PayConnection";
import {
  TALK2PAY_CONNECTION_MESSAGES,
  Talk2PayConnectionMessages,
} from "@/messages/platforms/talk2PayConnection/talk2Pay-connection.messages";
import translationService from "@/services/translation.service";
import { Language } from "@/types/language.types";

const Talk2PayConnectionPage: React.FC = () => {
  const { lang = "PT-BR" } = useParams<{ lang?: string }>();
  const [messages, setMessages] = useState<Talk2PayConnectionMessages | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const translations = await translationService.get<Talk2PayConnectionMessages>(
          TALK2PAY_CONNECTION_MESSAGES,
          (lang as Language) ?? null
        );
        setMessages(translations);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return null; // Loading handled by Suspense in child components
  }

  if (!messages) {
    return <div>Erro ao carregar mensagens</div>;
  }

  return <Talk2PayConnection messages={messages} />;
};

export default Talk2PayConnectionPage;
